import { useUserAgent } from './useUserAgent';

export const useIsAndroid = () => {
  return useUserAgent().includes('Android');
};
